import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=7658f980&scoped=true"
import script from "./CurrentUser.vue?vue&type=script&lang=js"
export * from "./CurrentUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7658f980",
  null
  
)

export default component.exports